module.exports = __webpack_public_path__ + "img/e-cross-logo-circle.cd1741b5.png";